import { render, staticRenderFns } from "./DetailsGroupe.vue?vue&type=template&id=9236553a&"
import script from "./DetailsGroupe.vue?vue&type=script&lang=ts&"
export * from "./DetailsGroupe.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsGroupe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports